import React from "react";
import { Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { LoanApi } from "../../../../services/Api/types";

interface Props {
	loan: LoanApi;
	redirectUri: string | null;
}

const LoanMissingData = ({ loan, redirectUri }: Props) => {
	const { t } = useTranslation("admin");

	return (
		<div className={"content-preview"}>
			<Alert variant={"danger"}>
				<div className={"d-flex flex-column"}>
					<span>
						{t("modules.loan.field.missing_data.title")} {!loan.reference_id && "numerze umowy"}{" "}
						{!loan.reference_id && (!loan.items || loan.items.length === 0) && "i "}{" "}
						{(!loan.items || loan.items.length === 0) && "urządzeniach"}
					</span>
					{redirectUri && <a href={redirectUri}>{t("common.action.back", { ns: "lib" })}</a>}
				</div>
			</Alert>
		</div>
	);
};
export default LoanMissingData;
